// extracted by mini-css-extract-plugin
export default {"menu":"Sidebar_menu__dxY8w","wrapper":"Sidebar_wrapper__IBCXN","list__item":"Sidebar_list__item__rfgXC","activeLink":"Sidebar_activeLink__7qdyw"};